import FingerprintJS from "@fingerprintjs/fingerprintjs-pro";

export const isBrowser =
  typeof window !== "undefined" && typeof document !== "undefined";

export const getBrowserInfo = () => {
  if (!isBrowser) {
    return {
      url: "",
      referrer: "",
      title: "",
      hostname: "",
    };
  }

  return {
    url: window.location.href,
    referrer: document.referrer,
    title: document.title,
    hostname: window.location.hostname,
  };
};

// New local storage implementation
export const getLocalStorage = () => {
  return {
    get: (key: string): string | null => {
      if (!isBrowser) return null;
      try {
        return localStorage.getItem(key);
      } catch (error) {
        console.error("Error accessing localStorage:", error);
        return null;
      }
    },
    set: (key: string, value: string): void => {
      if (!isBrowser) return;
      try {
        localStorage.setItem(key, value);
      } catch (error) {
        console.error("Error writing to localStorage:", error);
      }
    },
    remove: (key: string): void => {
      if (!isBrowser) return;
      try {
        localStorage.removeItem(key);
      } catch (error) {
        console.error("Error removing from localStorage:", error);
      }
    },
  };
};

// Browser fingerprinting utility
export const generateFingerprint = async () => {
  // Initialize the agent on application start.
  return await FingerprintJS.load({
    apiKey: "nsa806O1PfAKU3ax1n52",
  })
    .then((fp) => {
      // Get the visitor identifier when you need it.
      return fp.get();
    })
    .then((result) => {
      return result.visitorId;
    });
};
